export { default } from "./InputPassword";
